import { DoctorCardActions } from './DoctorCardActions';
import { PatientActions } from '../../actions/PatientActions';
import { SchedulingActions } from '../../actions/SchedulingActions';

const defaultState = {
    professional: undefined,
    patientName: undefined,
};

export const doctorCardReducer = (state = defaultState, action) => {
    switch (action.type) {
        case DoctorCardActions.SAVE_PROFESSIONAL: {
            return {
                ...state,
                professional: action.professional,
                hasProfessional: true,
            };
        }

        case PatientActions.PATIENT_RETRIEVED: {
            const { payload } = action;
            return {
                ...state,
                patientName: `${payload.first_name} ${payload.last_name}`,
            };
        }

        case SchedulingActions.UPDATE_LOCAL_BOOKING_STATE: {
            return {
                ...state,
                patientName: undefined,
            };
        }

        default:
            return state;
    }
};
